
// import React from 'react';
// import ReactDOM from 'react-dom';

// import './i18n';

// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import CookiesDemo from 'crm/other/Contact/CookiesDemo';
// import { HelmetProvider } from 'react-helmet-async'; 
// import { BrowserRouter } from 'react-router-dom';


// ReactDOM.render(
//     <React.StrictMode>
//         <BrowserRouter>
//             <HelmetProvider>
//                 <App />
//                 <CookiesDemo />
//             </HelmetProvider>
//         </BrowserRouter>
//     </React.StrictMode>,
//     document.getElementById('root')
// );

// // Performance measuring
// reportWebVitals();



import React from 'react';
import ReactDOM from 'react-dom';

import './i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';
import CookiesDemo from 'crm/other/Contact/CookiesDemo';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');

const AppWrapper = (
    <React.StrictMode>
        <BrowserRouter>
            <HelmetProvider>
                <App />
                <CookiesDemo />
            </HelmetProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// 🔥 IMPORTANT CHANGE
if (rootElement?.hasChildNodes()) {
    ReactDOM.hydrate(AppWrapper, rootElement);
} else {
    ReactDOM.render(AppWrapper, rootElement);
}

reportWebVitals();